<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form"
                          (confirmed)="onConfirmed($event)">
  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Offer amount from</mat-label>
      <input matInput
             type="text"
             currencyMask
             [formControl]="form.controls.offerAmountFrom">
    </mat-form-field>
  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Offer amount to</mat-label>
      <input matInput
             type="text"
             currencyMask
             [formControl]="form.controls.offerAmountTo">
    </mat-form-field>

  <ifc-account-loan-number-input [fc]="form.controls.loanNumber" baseFilterItem></ifc-account-loan-number-input>
  <ifb-business-name-input [fc]="form.controls.companyName" baseFilterItem></ifb-business-name-input>

  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Product type</mat-label>
      <mat-select [formControl]="form.controls.productCode"
                  placeholder="All">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let option of productTypeOptions"
                    [value]="option.value">{{ option.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

  </ifc-base-filter-dialog>
</form>
